// extracted by mini-css-extract-plugin
module.exports = {"regularFontWeight":"styles_regularFontWeight__3MD97","detail":"styles_detail__3BGFf"};